module.exports = {
  tip: {
    select: 'ជ្រើសរើស',
    input: 'សូមបញ្ចូល'
  },
  upload: {
    upload: 'ផ្ទុកឯកសារឡើង',
    tip: 'អូសឯកសារនៅទីនេះ ឬ'
  },
  date: {
    start: 'ថ្ងៃចាប់ផ្តើម',
    end: 'ថ្ងៃបញ្ចប់',
    t: 'ថ្ងៃនេះ',
    y: 'ម្សិលមិញ',
    n: 'ជិតប្រាំពីរថ្ងៃ',
    a: 'ទាំងអស់។'
  },
  form: {
    printBtn: 'បោះពុម្ព',
    mockBtn: 'ការក្លែងធ្វើ',
    submit: 'ដាក់ស្នើ',
    empty: 'លុប'
  },
  crud: {
    filter: {
      addBtn: 'បន្ថែមលក្ខខណ្ឌ',
      clearBtn: 'ទិន្នន័យ​យ៉ាង​ច្បាស់',
      resetBtn: 'ជម្រះលក្ខខណ្ឌសំណួរ',
      cancelBtn: 'បោះបង់',
      submitBtn: 'កំណត់'
    },
    column: {
      name: 'ឈ្មោះជួរឈរ',
      hide: 'លាក់',
      fixed: 'បង្កក',
      filters: 'តម្រង',
      screen: 'តម្រង',
      sortable: 'ការតម្រៀប',
      index: 'លំដាប់',
      width: 'ទទឹង'
    },
    tipStartTitle: 'currently selected',
    tipEndTitle: 'item',
    editTitle: 'កែប្រែ',
    copyTitle: 'ចម្លង',
    addTitle: 'បន្ថែម',
    viewTitle: 'ត្រួតពិនិត្យ',
    filterTitle: 'លក្ខខណ្ឌតម្រង',
    showTitle: 'showTitle',
    menu: 'ម៉ឺនុយ',
    addBtn: 'បន្ថែម',
    show: 'បង្ហាញ',
    hide: 'លាក់',
    open: 'open',
    shrink: 'រួញ',
    printBtn: 'បោះពុម្ព',
    excelBtn: 'excel',
    updateBtn: 'កែសម្រួល',
    cancelBtn: 'បោះបង់',
    searchBtn: 'ស្វែងរក',
    emptyBtn: 'លុប',
    menuBtn: 'មុខងារ',
    saveBtn: 'រក្សាទុកវា។',
    viewBtn: 'ត្រួតពិនិត្យ',
    editBtn: 'កែសម្រួល',
    copyBtn: 'ចម្លង',
    delBtn: 'លុប'
  }
}
